import { Injectable } from "@angular/core";
import { ApiClientService } from "./util/api.client.service";
import { StudyModuleDto } from "../model/studyModuleDto";
import { PofTeachersDto } from "../model/pofTeachersDto";

@Injectable()
export class StudyModuleService {
  constructor(private http: ApiClientService) {}

  getBySubLevel(subLevelId: number) {
    return this.http.get(`/secure/studymodule/sublevel/${subLevelId}`, {
      secure: false,
    });
  }

  createStudyModuleHasTeacher(studyModuleId: number, personId: number, educationalCenterId: number, curricularSpaceId: number, studentGroupId: number) {
    return this.http.post(`/secure/educationalcenter/${educationalCenterId}/studymodule/${studyModuleId}/person/${personId}/curricularspace/${curricularSpaceId}/studentGroup/${studentGroupId}`, {}, {
      secure: false,
    });
  }

  getStudyModuleHasTeacherList(subLevelId: number, educationalCenterId: number, curricularSpaceId: number, studentGroupId: number) {
    return this.http.get(`/secure/educationalcenter/${educationalCenterId}/studymodule/teacher/sublevel/${subLevelId}/curricularspace/${curricularSpaceId}/studentGroup/${studentGroupId}`, {
      secure: false,
    });
  }

  deleteStudyModuleHasTeacherList(studyModuleId: number, teacherId: number, studentGroupId: number, educationalCenterId: number, curricularSpaceId: number) {
    return this.http.delete(`/secure/educationalcenter/${educationalCenterId}/studymodule/${studyModuleId}/teacher/${teacherId}/curricularspace/${curricularSpaceId}?studentGroupId=${studentGroupId}`, {
      secure: false,
    });
  }

  // handleApiFeedback activa error/spinner centralizados en ApiClientService.
  getModulesBySubLevel(subLevelId: number, studentGroupId: number, handleApiFeedback: boolean = false) {
    return this.http.apiGet<StudyModuleDto[]>(`/secure/studymodule/sublevel/${subLevelId}/assignedteachers`, {
      secure: false,
      params: {
        studentGroupId: studentGroupId,
        educationalCenterId: this.http.getEducationalCenterId()
      },
      showSpinner: handleApiFeedback,
      handleError: handleApiFeedback
    });
  }

  // handleApiFeedback activa error/spinner centralizados en ApiClientService.
  getSubjectsByStudyModule(studyModuleId: number, handleApiFeedback: boolean = false) {
    return this.http.apiGet<PofTeachersDto[]>(`/secure/studymodule/${studyModuleId}/subject`, {
      secure: false,
      showSpinner: handleApiFeedback,
      handleError: handleApiFeedback
    });
  }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/study-module.service.ts